import React from 'react';
import DocumentStatusThree from '../../components/DocumentStatusThree';
import {
    DownloadProviderImage
} from '../../reduxToolkit/Providers/providersApi';
import DeleteModal from '../Modals/DeleteModal';
import HeadTittle from "../../components/HeadTittle";
import UserDocumentsApp from "./Functionality/UserDocumentsApp";
import DivContainerBody from "../../components/DivContainerBody";
import ButtonAction from "../../components/buttons/ButtonAction";
import {TrashOutlineIcon} from "../../components/buttons/IconButtons";
import CustomDescriptionLabel from "../../components/CustomDescriptionLabel";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

const UserDocuments = (props) => {
    const { docType } = props;
    const {t, selectDocumentsForDelete, setSelectDocumentsForDelete, deleteDocShow, setDeleteDocShow,
        isAllChecked, setIsAllChecked, deleteSelectedDocuments, information, dataTable, optionDownload, docValue, createDocValue,
        updated, setUpdated} = UserDocumentsApp(props);

    return (
        <>
            <HeadTittle name={t('documents_to_upload')}>
                <ButtonAction
                    id='btn_ud_delete'
                    name='delete'
                    className='btn-icon-delete'
                    disabled={selectDocumentsForDelete?.length === 0}
                    Icon={TrashOutlineIcon}
                    onClick={() => {
                        setDeleteDocShow(true);
                    }}
                />
            </HeadTittle>

            <DivContainerBody>
                <CustomDescriptionLabel trans={information} />

                <DocumentStatusThree
                    showBtnDelete={false}
                    dataTable={dataTable}
                    disabled={false}
                    userType={docType}
                    optionDownload={optionDownload}
                    isAllChecked={isAllChecked}
                    setIsAllChecked={setIsAllChecked}
                    selectDocumentsForDelete={selectDocumentsForDelete}
                    setSelectDocumentsForDelete={setSelectDocumentsForDelete}
                    setDocValue={docValue}
                    createDocValue={createDocValue}
                    downloadImg={DownloadProviderImage}
                    onUpdate={() => {
                        setUpdated(updated + 1);
                    }}
                    updated={updated}
                />
            </DivContainerBody>
            <DeleteModal
                show={deleteDocShow}
                onHide={() => setDeleteDocShow(false)}
                data={selectDocumentsForDelete}
                title_modal={t('delete_documents')}
                element_modal={t('documents')}
                isReset={setSelectDocumentsForDelete}
                isAllReset={setIsAllChecked}
                onClickFn={() => deleteSelectedDocuments(selectDocumentsForDelete)}
            />
        </>
    );
};

export default UserDocuments;
